export const conditionDataNamePrefix = `filterRow`
export default function keepConditionIntoView(conditionIndex: number) {
  setTimeout(() => {
    document
      .querySelector(`[data-name=${conditionDataNamePrefix}${conditionIndex}]`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' })
  }, 0)
}
